import React from "react"
import ReactDOM from "react-dom"
import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import { ReactReduxFirebaseProvider } from "react-redux-firebase"
import { createFirestoreInstance } from "redux-firestore"
import { BrowserRouter, Route, Switch } from "react-router-dom"

import "react-notification-alert/dist/animate.css"
import "react-perfect-scrollbar/dist/css/styles.css"

// import "assets/vendor/fullcalendar/dist/fullcalendar.min.css"
// import "assets/vendor/sweetalert2/dist/sweetalert2.min.css"
// import "assets/vendor/select2/dist/css/select2.min.css"
// import "assets/vendor/quill/dist/quill.core.css"
import "assets/vendor/nucleo/css/nucleo.css"
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css"
import "assets/scss/argon-dashboard-pro-react.scss?v1.1.0"
import "antd/dist/antd.css"
import "assets/css/custom.css"

import BeatLoader from "react-spinners/BeatLoader"

import AdminLayout from "layouts/Admin.js"
import MerchantLayout from "layouts/Merchant.js"
import AuthLayout from "layouts/Auth.js"
import IndexView from "views/Index.js"
import MerchantsList from "views/pages/MerchantsList.js"
import SingleMerchant from "views/pages/SingleMerchant.js"
import MyAccount from "views/pages/MyAccount.js"
import CustomerOrders from "views/pages/CustomerOrders.js"
import Schedule from "views/pages/Schedule.js"
import PrivacyPolicy from "views/pages/PrivacyPolicy.js"
import Terms from "views/pages/Terms.js"
import { ErrorPage, EmailVerify } from "components"
import ThankYou from "views/pages/ThankYou"

import { Provider } from "react-redux"
import configureStore from "store"
import { useSelector } from "react-redux"
import { isLoaded } from "react-redux-firebase"

function AuthIsLoaded({ children }) {
  const auth = useSelector((state) => state.firebase.auth)
  if (!isLoaded(auth)) {
    return (
      <div className="loading-center">
        <div className="sweet-loading">
          <BeatLoader size={15} color={"#2c3e50"} />
        </div>
      </div>
    )
  }
  return children
}

function ProfileIsLoaded({ children }) {
  const profile = useSelector((state) => state.firebase.profile)
  if (!isLoaded(profile)) {
    return (
      <div className="loading-center">
        <div className="sweet-loading">
          <BeatLoader size={15} color={"#2c3e50"} />
        </div>
      </div>
    )
  }
  return children
}

firebase.firestore()

const store = configureStore()
const rrfProps = {
  firebase,
  config: {
    userProfile: "customers",
    useFirestoreForProfile: true,
    enableClaims: true,
  },
  dispatch: store.dispatch,
  createFirestoreInstance,
}

function AuthAndProfileWrapper(component) {
  return (
    <AuthIsLoaded>
      <ProfileIsLoaded>{component}</ProfileIsLoaded>
    </AuthIsLoaded>
  )
}

const Loading = () => {
  return (
    <div className="loading-center">
      <div className="sweet-loading">
        <BeatLoader size={15} color={"#2c3e50"} />
      </div>
    </div>
  )
}

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <BrowserRouter>
        <Switch>
          <Route
            path="/merchants/:zipCode"
            render={(props) => <MerchantsList {...props} />}
            exact
          />
          <Route
            path="/merchant/:merchantId"
            render={(props) => <SingleMerchant {...props} />}
            exact
          />
          <Route
            path="/merchant/:merchantId/schedule"
            render={(props) => <Schedule {...props} />}
            exact
          />
          <Route
            path="/account"
            render={(props) => <MyAccount {...props} />}
            exact
          />
          <Route
            path="/orders"
            render={(props) => <CustomerOrders {...props} />}
            exact
          />
          <Route
            path="/privacy-policy"
            render={(props) => <PrivacyPolicy {...props} />}
            exact
          />
          <Route path="/terms" render={(props) => <Terms {...props} />} exact />
          <Route path="/l" render={() => <Loading />} />
          <Route
            path="/thankYou"
            render={(props) => AuthAndProfileWrapper(<ThankYou {...props} />)}
          />
          <Route
            path="/emailVerify"
            render={(props) =>
              AuthAndProfileWrapper(<EmailVerify {...props} />)
            }
          />
          <Route
            path="/m"
            render={(props) =>
              AuthAndProfileWrapper(<MerchantLayout {...props} />)
            }
          />
          <Route
            path="/d"
            render={(props) =>
              AuthAndProfileWrapper(<AdminLayout {...props} />)
            }
          />
          <Route
            path="/a"
            render={(props) => AuthAndProfileWrapper(<AuthLayout {...props} />)}
          />
          <Route
            path="/"
            render={(props) => AuthAndProfileWrapper(<IndexView {...props} />)}
            exact
          />
          <Route component={() => <ErrorPage />} />
        </Switch>
      </BrowserRouter>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
)
